const moment = require('moment')

const allowances = ({sport, type, registrationGroup}) => {
  let allowances = {
    weekday: 0,
    weekend: 0,
    either: 0
  }
  try {
    if(!registrationGroup)
      return allowances
    let ageGroups = registrationGroup.age_group.split(',').map(parseInt)
    if(sport === 'BASKETBALL') {
      if([3, 4, 5].some(grade => ageGroups.includes(grade))) {
        allowances.weekday++
        if(type === 'PRE_SEASON')
          allowances.weekend++
      } else if([6, 7, 8].some(grade => ageGroups.includes(grade))) {
        allowances.weekday++
        if(type === 'PRE_SEASON')
          allowances.either++
      } else if([9, 10, 11, 12].some(grade => ageGroups.includes(grade))) {
        if(type === 'SEASON')
          allowances.weekday++
      }
    } else if(sport === 'FLAG_FOOTBALL') {
      allowances.weekday++
      allowances.weekend++
    }
  } catch(err) {
    // do nothing
  }
  return allowances
}

const processFacility = ({facility, registrationGroup, sport}) => {
  let slotsRequired
  try {
    if(registrationGroup) {
      let ageGroups = registrationGroup.age_group.split(',').map(parseInt)
      if(sport === 'BASKETBALL') {
        if(facility.facility_type === 'COMMUNITY_CENTER') {
          slotsRequired = 1
        } else if([3, 4, 5].some(grade => ageGroups.includes(grade))) {
          if(facility.facility_type === 'ELEMENTARY_SCHOOL'){
            slotsRequired = 1
          }
        } else if([6, 7, 8, 9, 10, 11, 12].some(grade => ageGroups.includes(grade))){
          if(facility.facility_type === 'ELEMENTARY_SCHOOL') {
            slotsRequired = 2
          } else if(['MIDDLE_SCHOOL', 'HIGH_SCHOOL'].includes(facility.facility_type)) {
            slotsRequired = 1
          }
        }
      } else if(sport === 'FLAG_FOOTBALL') {
        slotsRequired = 1
      }
    }
  } catch(err) {
    slotsRequired = null
  }
  return {
    IS_AVAILABLE: slotsRequired ? true : false,
    SLOTS_REQUIRED: slotsRequired,
    ...facility
  }
}

const slots = ({facilities, pendingSessions, team, allowanceUsage, seasonId}) => {
  return facilities.reduce((acc, facility) => {
    facility.athletic_space.forEach(space => {
      space.facility_hours
        .filter(fh => fh.season_id == seasonId)
        .forEach(day => {
          let isWeekend = ['SATURDAY', 'SUNDAY'].includes(day.week_day)
          let target = isWeekend ? 'weekend' : 'weekday'
          let potentials = [...allowanceUsage[target], ...allowanceUsage.either]
          let allowed = potentials.some(thing => thing == 'free')
          day.session.forEach(session => {
            let key = `${day.week_day}-${moment(session.session_start_dtm).format('HH:mm')}-${moment(session.session_end_dtm).format('HH:mm')}`
            if(!(key in acc)){
              let start = moment(session.session_start_dtm)
              let end = moment(session.session_end_dtm)
              acc[key] = {
                allowed,
                reservableFacilities: 0,
                reservedBySelectedTeam: false,
                pendingReservation: false,
                pendingNowUnavailable: false,
                start: moment().day(day.week_day).hours(start.hours()).minutes(start.minutes()).format('YYYY-MM-DD HH:mm'),
                end: moment().day(day.week_day).hours(end.hours()).minutes(end.minutes()).format('YYYY-MM-DD HH:mm')
              }
            }
            let fullReservation = session.reservations.find(r => !r.breakout_id)
            let partialReservations = session.reservations.filter(r => r.breakout_id)
            let reservable = facility.SLOTS_REQUIRED == 2 ? !session.reservations.length : !fullReservation && partialReservations.length < space.slots
            if(reservable){
              acc[key].reservableFacilities++
            }
            if(session.reservations.some(reservation => reservation.team_id == team.id)) {
              acc[key].reservedBySelectedTeam = true
            }
            if(pendingSessions.some(p => p.space.session.id == session.id)){
              acc[key].pendingReservation = true
              if(!reservable)
                acc[key].pendingNowUnavailable = true
            }
          })
        })
    })
    return acc
  }, {})
}

const slotBreakdown = ({slot, facilities, pendingSessions, team, seasonId}) => {
  if(!slot)
    return []
  return facilities.map(facility => {
    let spaces = facility.athletic_space.map(space => {
      let dayOfWeek = moment(slot.start).format('dddd').toUpperCase()
      let timeIsEq = (a, b) => {
        let A = moment(a)
        let B = moment(b)
        return (A.hour() == B.hour() && A.minute() == B.minute())
      }
      let day = space.facility_hours
        .filter(fh => fh.season_id == seasonId)
        .find(day => day.week_day == dayOfWeek)
      if(!day)
        return null
      let session = day.session.find(session => {
        return timeIsEq(session.session_start_dtm, slot.start) &&
          timeIsEq(session.session_end_dtm, slot.end)
      })

      let slots = []
      if(session) {
        if(facility.SLOTS_REQUIRED == 1 && space.athletic_space_breakouts.length) {
          slots = space.athletic_space_breakouts.map(breakout => {
            let reservations = session.reservations.filter(r => r.breakout_id == breakout.id || !r.breakout_id)
            let status = {}
            status.full = reservations.length > 0
            status.reserved = reservations.some(r => r.team_id == team.id)
            status.pending = pendingSessions.some(p => p.space.session.id == session.id && p.breakout && p.breakout.id == breakout.id)
            status.available = !status.full && !status.reserved && !status.pending
            return {
              id: breakout.id,
              name: breakout.name,
              breakout,
              status
            }
          })
        } else {
          slots = [{
            id: -1,
            name: 'Full Space',
            breakout: null,
            status: {
              full: session.reservations.length > 0,
              reserved: session.reservations.some(r => r.team_id == team.id && !r.breakout),
              pending: pendingSessions.some(p => p.space.session.id == session.id && !p.breakout),
              available: !session.reservations.length > 0 && !session.reservations.some(r => r.team_id == team.id && !r.breakout) && !pendingSessions.some(p => p.space.session.id == session.id && !p.breakout)
            }
          }]
        }
      }

      let status = {
        full: slots.every(slot => slot.status.full),
        reserved: slots.some(slot => slot.status.reserved),
        pending: slots.some(slot => slot.status.pending),
        available: slots.some(slot => slot.status.available)
      }

      return {
        slots,
        status,
        session_id: session ? session.id : null,
        id: space.id,
        name: space.name,
        description: space.description,
        space_status: space.status,
        gym_basket_detail: space.gym_basket_detail,
        session
      }
    }).filter(space => space)
    let spaces_available = spaces.reduce((n, space) => space.status.available ? n+1 : n, 0)
    let reserved = spaces.some(space => space.status.reserved)
    let pending = spaces.some(space => space.status.pending)
    return {
      spaces_available,
      reserved,
      pending,
      id: facility.id,
      facility_name: facility.facility_name,
      description: facility.description,
      status: facility.status,
      athletic_space: spaces,
      SLOTS_REQUIRED: facility.SLOTS_REQUIRED
    }
  })
}

module.exports = {
  allowances,
  processFacility,
  slots,
  slotBreakdown
}